import { Palette } from '@mui/material'

export const carouselContainerStyle = (palette: Palette) => ({
	p: 3,
	flex: 1,
	minHeight: '250px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	textAlign: 'center',
	transition: 'all 0.3s ease',
	borderColor: palette.colors.grey,
	borderRadius: '8px',
	borderStyle: 'solid',
})
